import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState.js';

export const firstStep = createSlice({
  name: 'firstStep',
  initialState,
  reducers: {
    setIiipol: (state, action) => {
      state.iiipol = action.payload
    },
    setIntpol: (state, action) => {
      state.intpol = action.payload
    },
    setFrequentQuestions: (state, action) => {
      state.questions_product = action.payload
    },
    setStateNotebook: (state, action) => {
      state.protectedNotebook = { ...state.protectedNotebook, ...action.payload }
    },
    setStatePortableTechnology: (state, action) => {
      state.protectedTecnology = { ...state.protectedTecnology, ...action.payload }
    },
    setErrorEncrypt: (state, action) => {
      // //console.log(action.payload);
      state.errorEncrypt = action.payload;
    },
    setCodPme: (state, action) => {
      // //console.log(action.payload);
      state.codpme = action.payload;
    },
    setGlobalTab: (state, action) => {
      // //console.log(action.payload);
      state.globalTab = action.payload;
    },
    setCurrentTab: (state, action) => {
      // //console.log(action.payload);
      state.currentTab = action.payload;
    },
    setLoading: (state, action) => {
      // //console.log(action.payload);
      state.loading = action.payload;
    },
    setFirstStep: (state, action) => {
      // console.log(action.payload);
      state.firstStep = { ...state.firstStep, ...action.payload };
    },
    setAllSteps: (state, action) => {
      state.steps = [...state.steps, action.payload];
    },
    setCodpmpol: (state, action) => {
      // console.log(action.payload);
      state.codpmpol = action.payload;
    },
    setAltCodpmpol: (state, action) => {
      // console.log(action.payload);
      state.altCodpmpol = action.payload;
    },
    setTitularData: (state, action) => {
      state.titularData = { ...state.titularData, ...action.payload }
    },
    setPayMethod: (state, action) => {
      //console.log(action.payload);
      state.payMethod = { ...state.payMethod, ...action.payload };
    },
    setHomeData: (state, action) => {
      // console.log(action.payload)
      state.homeData = { ...state.homeData, ...action.payload };
    },
    setBeneficiaryData: (state, action) => {
      // console.log(action.payload)
      state.beneficiaryData = [...state.beneficiaryData, ...action.payload];
    },
    setDeleteBeneficiaryData: (state, action) => {
      const newArray = state.beneficiaryData.filter((e, ix) => {
        if (ix !== action.payload) {
          return e;
        }
      })
      // console.log(action.payload, newArray)
      state.beneficiaryData = newArray;
    },
    setHandleChangeBeneficiary: (state, action) => {
      // console.log(action.payload)
      state.beneficiaryData = action.payload;
    },
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
    setStateError: (state, action) => {
      // console.log(action.payload)
      state.stateError = action.payload;
    },
    setClientContainPlan: (state, action) => {
      // console.log(action.payload)
      state.clientContainPlan = action.payload;
    },
    setStatePlanDetail: (state, action) => {
      // console.log(action.payload)
      state.statePlanDetail = action.payload;
    },
    setEditBeneficiaries: (state, action) => {
      // console.log(action.payload)
      state.editBeneficiares = action.payload;
    },
    setAddOtherBeneficiary: (state, action) => {
      // console.log(action.payload)
      state.addOtherBeneficiary = action.payload;
    },
    setCompletedPurchase: (state, action) => {
      state.completedPurchase = action.payload;
    },
    setTypeBeneficiary: (state, action) => {
      state.typeBeneficiary = action.payload;
    },
    setUserContainProduct: (state, action) => {
      state.userContainProduct = action.payload;
    },
    setParamsMus: (state, action) => {
      state.paramsMus = { ...state.paramsMus, ...action.payload }
    },
    setFirstFormCompleted: (state, action) => {
      state.firstFormCompleted = action.payload;
    },
    setResetData: (state, action) => {
      state.firstFormCompleted = false,
        state.iiipol = '',
        state.intpol = '',
        state.questions_product = '',
        state.errorEncrypt = false,
        state.paramsMus = {
          ...state.paramsMus,
          product: ''
        },
        state.login = {
          ...state.login
        },
        state.codpme = '',
        state.user = {
          ...state.user
        },
        state.userContainProduct = false,
        state.typeBeneficiary = '',
        state.completedPurchase = false,
        state.addOtherBeneficiary = false,
        state.editBeneficiares = false,
        state.clientContainPlan = '',
        state.statePlanDetail = '',
        state.stateError = '',
        state.globalTab = 0,
        state.currentTab = 0,
        state.codpmpol = '',
        state.altCodpmpol = '',
        state.steps = [],
        state.loading = false,
        state.firstStep = {
          plan: '',
          codpro: '',
          price: '',
          codsec: '',
          codcia: '',
          fecpro: '',
        },
        state.titularData = {
          name: '',
          lastname: '',
          dni: '',
          email: '',
          city: '',
          province: '',
          area: '',
          phone: '',
          address: '',
          numAddress: '',
          birthday: '',
          genre: '',
          activity: 0,
          nationality: '54',
          expose: 'no',
          year: new Date().getFullYear(),
        },
        state.homeData = {
          address: '',
          homeType: '',
          province: '',
          // numAddress: '',
          // department: '',
          city: '',
          squareMeters: '',
          registeredAddress: '',
        },
        state.payMethod = {
          creditCard: '',
          cardNumber: '',
          fullName: '',
          dni: '',
          expires: '',
        },
        state.beneficiaryData = [],
        state.additionalData = ''
    },
  },
},
);


export const { setFrequentQuestions, setStateNotebook, setStatePortableTechnology, setErrorEncrypt, setCodPme, setParamsMus, setUserContainProduct, setTypeBeneficiary, setCompletedPurchase, setAltCodpmpol, setDeleteBeneficiaryData, setEditBeneficiaries, setAddOtherBeneficiary, setResetData, setFirstStep, setTitularData, setPayMethod, setHomeData, setBeneficiaryData,
  setHandleChangeBeneficiary, setCodpmpol, setAllSteps, setLoading, setAdditionalData, setCurrentTab, setGlobalTab, setStateError, setClientContainPlan, setStatePlanDetail, setIntpol, setIiipol, setFirstFormCompleted } = firstStep.actions;

